import React from 'react';
import { minMaxValidator } from '../../utils/validators';
import CurrencyField from '../CurrencyField';
import formatPercentage from '../../utils/formatters/formatPercentage';
import Field from '../Field';
import PercentageField from '../PercentageField';

const popoverMessages = {
  priceOfCar: {
    title: 'Price of Car',
    body: [
      'Enter the total sales price, but do not include registration, delivery costs, or other costs that are due up front.'
    ]
  },
  loanTerm: {
    title: 'Loan Term',
    body: [
      'Number of months it will take to pay off the loan.'
    ]
  },
  monthlyPayment: {
    title: 'Monthly Payment',
    body: [
      'Your monthly car payment (does not include insurance or maintenance).'
    ]
  }
};

function MobileCarComponent({ children, ...inputProps }) {
  const calculatedCarPayment = inputProps.calculatePayment(inputProps.car.priceOfCar, inputProps.car.loanTerm, inputProps.car.interestRate);

  return (
    <div>
      <div className="header-label">Car #{inputProps.carNum}</div>
      <CurrencyField
        name={"comparisonCar"+inputProps.carNum+".priceOfCar"}
        label="Price of car"
        value={inputProps.car.priceOfCar}
        popover={popoverMessages.totalMonthlyIncome}
        onChange={(e, value) => inputProps.handleComparisonChange(value, 'comparisonCar'+inputProps.carNum, 'priceOfCar') }
      />
      <Field
        type="select"
        name={"comparisonCar"+inputProps.carNum+".loanTerm"}
        label="Loan term (in months)"
        value={inputProps.car.loanTerm}
        choices={inputProps.loanTermOptions}
        onChange={(e, value) => inputProps.handleComparisonChange(value, 'comparisonCar'+inputProps.carNum, 'loanTerm') }
      />
      <PercentageField
        name={"comparisonCar"+inputProps.carNum+".interestRate"}
        label="Interest Rate"
        value={inputProps.car.interestRate}
        onChange={(e, value) => inputProps.handleComparisonChange(value, 'comparisonCar'+inputProps.carNum, 'interestRate') }
        validator={minMaxValidator(0.01, 99.99, formatPercentage)}
        onValidation={inputProps.onValidation}
      />
      <CurrencyField
        name={"comparisonCar"+inputProps.carNum+".monthlyPayment"}
        label="Monthly payment"
        value={inputProps.car.monthlyPayment}
        popover={popoverMessages.monthlyPayment}
        calculatedValue={calculatedCarPayment}
        onChange={(e, value) => inputProps.handleComparisonChange(value, 'comparisonCar'+inputProps.carNum, 'monthlyPayment') }
        onValidation={inputProps.onValidation}
        disabled={true}
      />
    </div>
  )
}

export default MobileCarComponent



// WEBPACK FOOTER //
// ./src/components/CarComparisonGroup/MobileCarComponent.js